// extracted by mini-css-extract-plugin
export default {"container":"languageMenu-module--container--b801L","content":"languageMenu-module--content--lKxD5"};